import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  MobileAppFeaturePerson,
  MobileAppFeatureReal,
  MobileAppFeatureOffline,
  MobileAppFeaturePush,
  MobileAppFeatureSocial,
  MobileAppFeaturePathway,
  MobileAppFeatureAR,
  MobileAppFeatureChatbot,
  MobileAppFeatureVoice,
  MobileAppFeaturelanguage,
} from "../../../app-constants";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Industryukapp() {
  return (
    <section className="industry_uk_app mobile_app_industry tekrevol_dark_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>High-Value Features for High-Performance Apps</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Our mobile application development services are designed to
              integrate essential, high-performance features into your mobile
              app. Real-time analytics for immediate insights. Offline
              functionality to ensure continuous operation. AI-driven chatbots
              for intelligent user interaction. AR/VR experiences for immersive
              engagement. Secure payment gateways for flawless transactions.
              Every feature is engineered for speed, reliability, and
              scalability to deliver future-ready applications.
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="industy_uk_main">
              <div className="industy_uk_item">
                <div className="industry_uk_icon">{MobileAppFeaturePerson}</div>
                <div className="industry_uk_content">
                  <h5>Personalization</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">{MobileAppFeatureReal}</div>
                <div className="industry_uk_content">
                  <h5>Real-time Analytics</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  {MobileAppFeatureOffline}
                </div>
                <div className="industry_uk_content">
                  <h5>Offline Functionality</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">{MobileAppFeaturePush}</div>
                <div className="industry_uk_content">
                  <h5>Push Notifications</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">{MobileAppFeatureSocial}</div>
                <div className="industry_uk_content">
                  <h5>Social Media Integration</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  {MobileAppFeaturePathway}
                </div>
                <div className="industry_uk_content">
                  <h5>Payment Gateway Integration</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">{MobileAppFeatureAR}</div>
                <div className="industry_uk_content">
                  <h5>AR/VR Experiences</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  {MobileAppFeatureChatbot}
                </div>
                <div className="industry_uk_content">
                  <h5>Chatbot Integration</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">{MobileAppFeatureVoice}</div>
                <div className="industry_uk_content">
                  <h5>Voice Recognition</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  {MobileAppFeaturelanguage}
                </div>
                <div className="industry_uk_content">
                  <h5>Multi-language Support</h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Consult Project Scope
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Industryukapp;
